import React from "react";

import { useNavigateToLink } from "../../../components/react/link";
import { BreadcrumbLayout } from "../BreadcrumbLayout";

export const HomeBreadcrumb: React.FC = () => {
	const link = useNavigateToLink("/", {
		search: ["timeRange", "timestamp", "detachedFilters"],
	});

	return <BreadcrumbLayout label="Home" to={link} />;
};
